// extracted by mini-css-extract-plugin
export default {"landingLogo":"Logo_landingLogo__6oiGP"};